import { cn } from '../../lib/utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function Container({ children, className }: ContainerProps) {
  return (
    <div className={cn('w-full px-4 sm:px-6 lg:px-8 xl:px-16 2xl:px-24', className)}>
      {children}
    </div>
  );
}
